import React from "react";

import { EhrRefreshControl } from "@components/EhrRefreshControl/EhrRefreshControl";
import { useManualRefreshProgramming } from "@pages/ClinicalReportDetails/ReportPage/hooks/useManualRefreshProgramming";

export interface GoalsSyncButtonProps {}

export const GoalsSyncButton: React.FC<GoalsSyncButtonProps> = ({}) => {
  const refreshState = useManualRefreshProgramming();
  return <EhrRefreshControl refreshState={refreshState} analyticsSource="report_goals_step" />;
};
